import { postWithJWT } from '../http/fetch'
import { settingGet } from '../redux/util'

export const sendWebPushNotification = async (clientId, data) => {
  const cmsHost = settingGet('cmsHost')

  await postWithJWT(`${cmsHost}/api/notifications/broadcast/${clientId}/immediate`, data)
}
